import {IBreadcrumbs} from './breadcrumbs.interface';

export class Breadcrumbs<T> implements IBreadcrumbs{
	private _crumbs	: Array<T> = [];
	private _activeLevel : number = -1;


	constructor(list:T[] = []){
		list.forEach( e => this.push(e));
	}
	public push(elm:T){
		this._activeLevel++;
		this._crumbs = this._crumbs.slice(0,this._activeLevel);
		this._crumbs.push(elm);
	}

	public setActiveLevel(level:number){
		if(level < this._crumbs.length){
			this._activeLevel = level;
			return true;
		}
		return false;
	}

	public getActiveLevel(){
		return this._activeLevel;
	}

	public getActiveElm(){
		return this._crumbs[this.getActiveLevel()];
	}

	public asList(){
		return this._crumbs.slice();
	}

	public size(){
		return this._crumbs.length;
	}

	public isEmpty() {
		return this._crumbs.length === 0;
	}
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/infra/dataStructures/collections/breadcrumbs/breadcrumbs.structure.ts